import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || '';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_PUBLISHABLE_KEY || '';

// Log configuration on startup (only in development)
if (process.env.NODE_ENV === 'development' || !supabaseUrl || !supabaseAnonKey) {
    console.log('🔧 Supabase Configuration:');
    console.log('🔧 URL:', supabaseUrl || '❌ MISSING');
    console.log('🔧 Anon Key:', supabaseAnonKey ? `${supabaseAnonKey.substring(0, 20)}...` : '❌ MISSING');
    
    if (!supabaseUrl || !supabaseAnonKey) {
        console.error('❌ CRITICAL: Supabase credentials are missing!');
        console.error('❌ Make sure REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_PUBLISHABLE_KEY are set in .env');
    }
}

// Test if localStorage is available
const isLocalStorageAvailable = () => {
    try {
        const test = '__supabase_test__';
        window.localStorage.setItem(test, test);
        window.localStorage.removeItem(test);
        return true;
    } catch {
        console.error('❌ localStorage is not available! Session will not persist.');
        return false;
    }
};

console.log('🔧 localStorage available:', isLocalStorageAvailable());

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
    auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
        storage: window.localStorage,
        storageKey: 'supabase.auth.token',
        // Implicit (not PKCE): the magic link is minted server-side by the Polar
        // webhook, so there is no browser-stored code verifier to complete a
        // PKCE exchange. Implicit carries the session in the URL hash, which
        // detectSessionInUrl consumes with no verifier - so clicking the emailed
        // link logs the user in and opens the dashboard. Also works for the
        // user-initiated /login form.
        flowType: 'implicit',
    },
});

// Database types
export interface UserProfile {
    id: string;
    email: string;
    created_at: string;
    has_paid: boolean;
    polar_customer_id?: string;
    subscription_start_date?: string;
    assessment_completed: boolean;
    assessment_completed_at?: string;
}

